/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */
import { isAfter, isBefore } from 'date-fns';
import { Lottery } from '../types/lottery';

export default function mapLotteries(lotteries: Lottery[], exclusions = '') {
    const payload: {
        open: Lottery[];
        future: Lottery[];
        past: Lottery[];
    } = { open: [], future: [], past: [] };
    lotteries.forEach((value) => {
        if (value.display_at && isAfter(new Date(value.display_at), new Date())) {
            return;
        }
        // if lottery inventory id is on exclusion list, do not include in payload
        if (exclusions.includes(value.inventory_id)) {
            return;
        }

        if (value.close_at && isBefore(new Date(value.close_at), new Date())) {
            payload.past.push(value);
            return;
        }
        if (value.open_at && isBefore(new Date(value.open_at), new Date())) {
            payload.open.push(value);
            return;
        }
        payload.future.push(value);
    });

    return payload;
}
